import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { CapasContent } from './components/CapasContent';

export default function Capas() {
    return (
        <>
            <MainContent
                component={<CapasContent />}
                titulo={`Gestión de CAPA`}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
